// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"28821265","219":"296b4a7c","351":"019b4575","455":"399606b7","499":"3020bbd9","555":"526868f7","728":"6ab95ad3","797":"16a6b632","852":"efabf713","914":"4d851bfa","936":"04ce2972"}[chunkId] + ".chunk.js";
};